import { Component } from "react";
import * as Sentry from "@sentry/react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Erreur capturée :", error, info);
    Sentry.captureException(error, { contexts: { react: info } });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <div
          style={{
            padding: "32px 24px",
            textAlign: "center",
            color: "var(--color-text-muted)",
          }}
        >
          <div
            style={{
              fontSize: 16,
              fontWeight: 600,
              color: "var(--color-text)",
              marginBottom: 8,
            }}
          >
            Une erreur inattendue s&apos;est produite.
          </div>
          <div style={{ fontSize: 14 }}>
            Rechargez la page ou contactez le support si le problème persiste.
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
